// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/shopify/extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/shopify/extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._k-0 {\n  font-weight: 600;\n}\n\n._k-1 {\n  width: 20px;\n  height: 20px;\n}\n\n._k-2 {\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: underline;\n  color: var(--redo-colors-blue-500);\n}\n", ""]);
// Exports
export var estimate = "_k-0";
export var truckIcon = "_k-1";
export var zipCode = "_k-2";
export default ___CSS_LOADER_EXPORT___;
